import { LocalStorage } from '../storage';

// Single localStorage entry holding all per-user UI preferences as JSON,
// keyed per option (e.g. one key per module's sidebar-collapsed state),
// instead of one raw localStorage key per preference.
const USER_OPTIONS_KEY = 'user-options';

const getUserOption = <T>(key: string, defaultValue: T): T => {
  const options = LocalStorage.get(USER_OPTIONS_KEY, {} as Record<string, T>);
  return key in options ? options[key] : defaultValue;
};

const setUserOption = <T>(key: string, value: T): void => {
  const options = LocalStorage.get(USER_OPTIONS_KEY, {} as Record<string, T>);
  LocalStorage.set(USER_OPTIONS_KEY, { ...options, [key]: value });
};

export { getUserOption, setUserOption };
